import React from 'react';

const RemoteConfigContext = React.createContext(null);

export default RemoteConfigContext;
